<template>
  <div id="app">
    <div id="app_content">
      <router-view></router-view>
      <hwPartLoad></hwPartLoad>
    </div>
  </div>
</template>

<script>
import "./fetch/link"
import hwPartLoad from "./components/hw-part-load.vue"
import {mapState,mapMutations,mapActions } from 'vuex'
export default {
  name: 'App',
  components:{hwPartLoad},
  created(){
    if(window.sessionStorage['token']){
      this.$store.dispatch('storeToken',{token : window.sessionStorage['token']});
    }
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    this.$store.state.is_webkit = (/WebKit/).test(userAgent);
    var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    var isIE = ((userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1)  || userAgent.indexOf('Windows NT') > -1 )&& !isOpera; //判断是否IE浏览器
    this.$store.state.is_ie = isIE;
    var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
    var isSafari = userAgent.indexOf("Safari") > -1; //判断是否Safari浏览器
    if (isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      var reIE1 = new RegExp("Windows NT (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      reIE1.test(userAgent);
      var fIEVersion1 = parseFloat(RegExp["$1"]);
      if(fIEVersion < 10 || fIEVersion1 < 6.2){
        this.$store.state.browser_ver = false;
      }
    }
    if (isFF) {
        //10  3.6
      let v = userAgent.match(/Firefox\/.+/g)[0].split(' ')[0].split("/");
      if(parseInt(v) < 10){
        this.$store.state.browser_ver = false;
      }
    }
    if (isSafari) {
        //15 18
      if(userAgent.match(/Chrome\/.+/g)[0]){
        let v = userAgent.match(/Chrome\/.+/g)[0].split(' ')[0].split('/')[1];
        if(parseInt(v) < 18){
          this.$store.state.browser_ver = false;
        }
      }else{
        this.$store.state.browser_ver = false;
      }
    }
    if(isOpera){
        //11.5 12.1
      let v = userAgent.match(/Opera\/.+/g)[0].split(' ')[0].split('/')[1];
      if(parseInt(v) < 12.1){
        this.$store.state.browser_ver = false;
      }
    }
  },
  methods:{
    routeChange(to,from){
//          浏览器版本不符合不进入
      var address= window.location.href;
      if(!this.$store.state.browser_ver){
        this.$router.push('/versionTip');
      }
      else if (!address.match('myScience')){
        var metas = document.getElementsByTagName('meta');
        for(var i =0; i<metas.length; i++){
          if(metas[i].name == 'referrer'){
            metas[i].content = 'origin';
          }
        }
      };
//          执行清除session操作
      if(to.meta.clearSession){
        to.meta.clearSession.forEach((v)=>{
          sessionStorage.removeItem(v);
        })
      }
//          执行清除storage操作
      if(to.meta.clearLocal){
        to.meta.clearLocal.forEach((v)=>{
          localStorage.removeItem(v);
        })
      }
    }
  },
  watch : {
      '$route' : 'routeChange'
  }
}
</script>

<style lang="scss" >
  @import "./assets/css/reset";
  @import "./assets/css/common";
  body{
    width: 100%;
    height: 100%;
    background: white;
    overflow: hidden;
  }#sogou_secure_inputs_container{display:none;}
  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    font-family: "Microsoft Yahei";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width: 100%;
    height: 100%;
    padding-top: 1px;
  }
  #app_content{
    height: 100%;
  }
  @media screen  and (max-width: 1200px){
    body{
      overflow-x: scroll;
    }
    #app{
      width: 1200px;
    }
  }
  @media screen  and (max-height: 700px){
    body{
      overflow-y: scroll;
    }
    #app{
      height: 700px;
    }
  }
  /*字体图标样式*/
  @font-face {
    font-family: 'icomoon';
    src:  url('../static/font/icomoon.eot?sewvqa');
    src:  url('../static/font/icomoon.eot?sewvqa#iefix') format('embedded-opentype'),
    url('../static/font/icomoon.ttf?sewvqa') format('truetype'),
    url('../static/font/icomoon.woff?sewvqa') format('woff'),
    url('../static/font/icomoon.svg?sewvqa#icomoon') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-science-none:before {
    content: "\e94a";
    color: #a3b0c9;
  }
  .icon-science-select:before {
    content: "\e94b";
    // color: #6e7997;
  }
  .icon-upload:before {
    content: "\e94c";
    color: #dfe5ef;
  }
  .icon-visible_1:before {
    content: "\e908";
    color: #2178ef;
  }
  .icon-visible_2:before {
    content: "\e946";
    color: #2178ef;
  }
  .icon-rotate:before {
    content: "\e949";
    color: #fff;
  }
  .icon-lookOrder:before {
    content: "\e948";
    color: #dfe5ef;
  }
  .icon-tea:before {
    content: "\e947";
    color: #dfe5ef;
  }
  .icon-voice:before {
    content: "\e907";
    color: #2178ef;
  }
  .icon-device-service .path1:before {
    content: "\e942";
    color: rgb(101, 172, 255);
  }
  .icon-device-service .path2:before {
    content: "\e943";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-device-service .path3:before {
    content: "\e944";
    margin-left: -1em;
    color: rgb(101, 172, 255);
  }
  .icon-device-service .path4:before {
    content: "\e945";
    margin-left: -1em;
    color: rgb(101, 172, 255);
  }
  .icon-inquiry-service:before {
    content: "\e92b";
    color: #0092ff;
  }
  .icon-family-service:before {
    content: "\e92c";
    color: #f9b55a;
  }
  .icon-chat-chart:before {
    content: "\e931";
    color: #a3b0c9;
  }
  .icon-chat-order:before {
    content: "\e934";
    color: #a3b0c9;
  }
  .icon-chat-photo:before {
    content: "\e935";
    color: #a3b0c9;
  }
  .icon-chat-info:before {
    content: "\e936";
    color: #0092ff;
  }
  .icon-chat-empty:before {
    content: "\e937";
    color: #dfe5ef;
  }
  .icon-chat-send-chart .path1:before {
    content: "\e938";
    color: rgb(42, 140, 255);
  }
  .icon-chat-send-chart .path2:before {
    content: "\e939";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-chat-send-chart .path3:before {
    content: "\e93a";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-chat-send-chart .path4:before {
    content: "\e93b";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-chat-send-chart .path5:before {
    content: "\e93c";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-chat-send-science .path1:before {
    content: "\e93d";
    color: rgb(44, 205, 255);
  }
  .icon-chat-send-science .path2:before {
    content: "\e93e";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-chat-send-science .path3:before {
    content: "\e93f";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-warning:before {
    content: "\e940";
    color: #fe654c;
  }
  .icon-chat-free:before {
    content: "\e941";
    color: #2178ef;
  }
  .icon-pack_up:before {
    content: "\e91d";
  }
  .icon-time1:before {
    content: "\e91b";
    color: #b8c2da;
  }
  .icon-delete:before {
    content: "\e91c";
    color: #b8c2da;
  }
  .icon-contact-tree:before {
    content: "\e91a";
    color: #b8c2da;
  }
  .icon-patient:before {
    content: "\e90b";
    color: #a6c9f9;
  }
  .icon-consult:before {
    content: "\e91e";
    color: #a6c9f9;
  }
  .icon-order:before {
    content: "\e91f";
    color: #a6c9f9;
  }
  .icon-science:before {
    content: "\e920";
    color: #a6c9f9;
  }
  .icon-patient-add:before {
    content: "\e921";
    color: #b8c2da;
  }
  .icon-refer:before {
    content: "\e922";
    color: #b8c2da;
  }
  .icon-order-time .path1:before {
    content: "\e923";
    color: rgb(184, 194, 218);
  }
  .icon-order-time .path2:before {
    content: "\e924";
    margin-left: -1em;
    color: rgb(184, 194, 218);
  }
  .icon-order-time .path3:before {
    content: "\e925";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-order-time .path4:before {
    content: "\e926";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-order-time .path5:before {
    content: "\e927";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-order-time .path6:before {
    content: "\e928";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-order-time .path7:before {
    content: "\e929";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-order-time .path8:before {
    content: "\e92a";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-triangle-up:before {
    content: "\e92d";
    color: #2178ef;
  }
  .icon-triangle-down:before {
    content: "\e92e";
    color: #b8c2da;
  }
  .icon-search:before {
    content: "\e92f";
    color: #b8c2da;
  }
  .icon-edit-1:before {
    content: "\e930";
    color: #b8c2da;
  }
  .icon-empty-data:before {
    content: "\e932";
    color: #b8c2da;
  }
  .icon-empty-text:before {
    content: "\e933";
    color: #b8c2da;
  }
  .icon-vip:before {
    content: "\e90c";
    color: #2a8cff;
  }
  .icon-close:before {
    content: "\e90d";
    color: #999;
  }
  .icon-head_male .path1:before {
    content: "\e90e";
    color: rgb(66, 74, 96);
  }
  .icon-head_male .path2:before {
    content: "\e90f";
    margin-left: -1em;
    color: rgb(251, 206, 157);
  }
  .icon-head_male .path3:before {
    content: "\e910";
    margin-left: -1em;
    color: rgb(108, 121, 122);
  }
  .icon-head_male .path4:before {
    content: "\e911";
    margin-left: -1em;
    color: rgb(231, 236, 237);
  }
  .icon-head_male .path5:before {
    content: "\e912";
    margin-left: -1em;
    color: rgb(204, 213, 214);
  }
  .icon-head_male .path6:before {
    content: "\e913";
    margin-left: -1em;
    color: rgb(56, 69, 79);
  }
  .icon-head_male .path7:before {
    content: "\e914";
    margin-left: -1em;
    color: rgb(84, 106, 121);
  }
  .icon-head_male .path8:before {
    content: "\e915";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }
  .icon-contacts:before {
    content: "\e916";
    color: #999;
  }
  .icon-tip:before {
    content: "\e917";
    color: #999;
  }
  .icon-photo:before {
    content: "\e918";
  }
  .icon-edit:before {
    content: "\e919";
    color: #2a8cff;
  }
  .icon-success:before {
    content: "\e900";
    color: #999;
  }
  .icon-down-arrow:before {
    content: "\e901";
    color: #ccc;
  }
  .icon-visible:before {
    content: "\e902";
    color: #2a8cff;
  }
  .icon-lock:before {
    content: "\e903";
    color: #999;
  }
  .icon-time:before {
    content: "\e904";
    color: #2a8cff;
  }
  .icon-wechat:before {
    content: "\e905";
    color: #74c731;
  }
  .icon-no-pass:before {
    content: "\e906";
    color: #2a8cff;
  }
  .icon-visible_2:before {
    content: "\e946";
    color: #2a8cff;
  }
  .icon-visible_1:before {
    content: "\e908";
    color: #2a8cff;
  }
  .icon-code:before {
    content: "\e909";
    color: #999;
  }
  .icon-account:before {
    content: "\e90a";
    color: #999;
  }









  /*单独字体大小设置*/

  .icon-visible:before {
    font-size: 26px;
  }
  .icon-lock:before {
    font-size: 20px;
  }
  .icon-visible_2:before {
    font-size: 14px;
  }
  .icon-code:before {
    font-size: 20px;
  }
  .icon-account:before {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue